import { render, staticRenderFns } from "./commandSidebarAddNewProduct.vue?vue&type=template&id=7132683b&"
import script from "./commandSidebarAddNewProduct.vue?vue&type=script&lang=js&"
export * from "./commandSidebarAddNewProduct.vue?vue&type=script&lang=js&"
import style0 from "./commandSidebarAddNewProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports